export default __webpack_public_path__ + "static/media/322.85a3cea6.jpg";